// track/components/MerchantLinkModal.tsx
import React from 'react';

interface MerchantLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  merchantName: string;
}

const MerchantLinkModal: React.FC<MerchantLinkModalProps> = ({ isOpen, onClose, onConfirm, merchantName }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Link Merchant to Vendor</h3>
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            Would you like to link the merchant "{merchantName}" to this vendor for future automatic categorization?
          </p>
          <p className="text-xs text-gray-500">
            This will help automatically assign future transactions from this merchant to the selected vendor.
          </p>
        </div>
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Not Now
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Link Merchant
          </button>
        </div>
      </div>
    </div>
  );
};

export default MerchantLinkModal;